"use strict";

var from = require("./from")

  , isArray = Array.isArray;

module.exports = function (arrayLike) {
	return isArray(arrayLike) ? arrayLike : from(arrayLike);
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/array/to-array.js
// module id = 968
// module chunks = 0